import { render, staticRenderFns } from "./saleGoodsDetail.vue?vue&type=template&id=8d904662&scoped=true&"
import script from "./saleGoodsDetail.vue?vue&type=script&lang=js&"
export * from "./saleGoodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./saleGoodsDetail.vue?vue&type=style&index=0&id=8d904662&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d904662",
  null
  
)

export default component.exports